export default "/images/9d5ddad45634c1bfd80f18ab19923528.avif";